import Camera from "./Camera";
import Layer from "./Layer";
import LayerGroup from "./LayerGroup";
import NodeLayer from "./NodeLayer";

export default class Scene {
  private _camera = new Camera();
  private _rootLayerGroup = new LayerGroup();
  private _startLayer: NodeLayer = null;

  public get startLayer(): NodeLayer {
    return this._startLayer;
  }

  public setStartLayer(layer: NodeLayer) {
    this._startLayer = layer;
  }

  public get camera(): Camera {
    return this._camera;
  }

  public setCamera(cam: Camera) {
    this._camera = cam;
  }

  public get rootLayerGroup(): LayerGroup {
    return this._rootLayerGroup;
  }

  //   public setNewGroupLayer(groupLayer: LayerGroup) {
  //     return (this._rootLayerGroup = groupLayer);
  //   }
}
